<template>
  <div v-if="fileList.length > 0">
    <div v-for="(f, index) in fileList" :key="index">
      <div
        class="px-4 mb-4 d-block alert alert-secondary"
        style="border-radius: 4px"
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <div
              class="avatar-md rounded-circle mr-4 bg-light-primary"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                width="80"
                v-if="
                  getExt(f.photoName) == 'jpg' ||
                  getExt(f.photoName) == 'png' ||
                  getExt(f.photoName) == 'jpeg' ||
                  getExt(f.photoName) == 'svg' ||
                  getExt(f.photoName) == 'gif'
                "
                :src="`${baseUrl}/${f.uploadPath}`"
              />
              <i
                style="font-size: 22px"
                v-else-if="getExt(f.photoName) == 'txt'"
                class="fa fa-file"
              ></i>
              <img
                v-else-if="getExt(f.photoName) == 'pdf'"
                src="@/assets/images/pdf.png"
                width="60"
              />
              <img
                v-else-if="
                  getExt(f.photoName) == 'doc' || getExt(f.photoName) == 'docx'
                "
                src="@/assets/images/word.png"
                width="60"
              />
              <i v-else style="font-size: 22px" class="fa fa-file"></i>
            </div>
            <div class="text-left">
              <h3 class="alert-title">
                <span class="pre">{{ f.photoName }}</span>
              </h3>
              <p class="alert-content">
                <strong>{{ $t("updatedDate") }}:</strong>
                {{ f.updatedDate || f.updateDate }}
              </p>
            </div>
          </div>
          <div class="float-right">
            <b-button-group class="">
              <a
                :href="`${getBaseUrl}/${f.uploadPath}`"
                :download="`${f.fileName}`"
                class="btn btn-outline-primary btn-hover-primary"
                target="_blank"
              >
                <i class="fa fa-download"></i>
                {{ $t("actions.download") }}
              </a>
            </b-button-group>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="not-found">
      {{ $t("warning.noInformation") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileList: {
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    getBaseUrl() {
      return process.env.VUE_APP_ROOT_URL;
    },
  },
  methods: {
    getExt(filename) {
      return filename.split(".").pop().toLowerCase();
    },
    getFileSize(size) {
      var fSExt = new Array("Bytes", "KB", "MB", "GB"),
        i = 0;
      while (size > 900) {
        size /= 1024;
        i++;
      }
      var exactSize = Math.round(size * 100) / 100 + " " + fSExt[i];
      return exactSize;
    },
  },
};
</script>

<style>
.not-found {
  min-height: 150px;
  font-size: 32px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #fff;
}
</style>